import React from 'react';
import PropTypes from 'prop-types';
import css from './CreativeEmptyState.css';
import TutorialSteps from '../../../utilities/tutorialSteps/TutorialSteps';

export const CreativeEmptyState = ({ title, stepsCount, stepsPrefix, icon }) => {
    const params = {
        icon,
        title,
        steps: [...Array(stepsCount)].map((_, index) => `${stepsPrefix}.${index + 1}`),
    };

    return (
        <div className={css.creativeEmptyState}>
            <TutorialSteps {...params} />
        </div>
    );
};

CreativeEmptyState.propTypes = {
    title: PropTypes.string.isRequired,
    stepsCount: PropTypes.number.isRequired,
    stepsPrefix: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
};

